/**
 * Copyright © 2025-2026 Cognizant Digital Business, Evolutionary AI.
 * All Rights Reserved.
 * Issued under the Academic Public License.
 */
// END COPYRIGHT
const API_ENV_URL = process.env["REACT_APP_API_URL"];
// Trim trailing slashes from `REACT_APP_API_URL` if provided.
export const API_BASE_URL = API_ENV_URL ? API_ENV_URL.replace(/\/+$/u, "") : "http://localhost:8000";
